export default __webpack_public_path__ + "static/media/arrow-left.1c161da0.svg";